import styled, { keyframes, css } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const overlayBase = css`
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 9999;
  animation: ${fadeIn} 0.2s ease;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  background: color-mix(in srgb, var(--bg-input, #fbfbfd) 80%, transparent);
`;

export const Overlay = styled.div`
  ${overlayBase}
`;

export const OverlayText = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: var(--dark, #29293a);
  letter-spacing: 0.2px;
`;
